export default __webpack_public_path__ + "images/bd0c9c0c62ec0d678491856503d2fda3-wine.webp";